import { Navigate, Outlet } from "react-router-dom";

const AuthRoutes = ({ isLoggin }: { isLoggin: boolean }) => {
  return isLoggin ? <Outlet /> : <Navigate to="/signin" replace />;
};

export default AuthRoutes;
